import React from 'react';
import { commandNameMap } from '../../utils/textMappings';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import {
  SplitButton,
  SplitButtonItemClickEvent,
} from '@progress/kendo-react-buttons';
import { GetString } from '../StringResourceManager';

export default function GenericSplitButton(props: {
  supportedCommands: ApiEnums.AlertCommand[];
  recommendedCommand: ApiEnums.AlertCommand;
  text: string;
  disabled: boolean;
  sendCommand: (command: ApiEnums.AlertCommand) => void;
}): JSX.Element {
  const handleCommandButtonClick = (event: SplitButtonItemClickEvent) => {
    props.sendCommand(props.supportedCommands[event.itemIndex]);
  };

  return (
    <React.Fragment>
      <SplitButton
        disabled={props.disabled}
        text={props.text}
        onItemClick={handleCommandButtonClick}
        items={props.supportedCommands.map((option, index) =>
          GetString(commandNameMap(option))
        )}
      />
    </React.Fragment>
  );
}
